/**
 * Onboarding tally (S04) — optional Tally migration intent.
 *
 * @see prototype/onboarding/tally.html — V1.1 Studio Slate baseline
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import {
  OnboardingShell,
  OnboardingHeader,
  Stepper,
  Hero,
  STEP_TITLES,
} from "../../../features/onboarding/components/index.ts";
import { ChevronRight } from "lucide-react";
import { TallyForm } from "../../../features/onboarding/components/tally-form.tsx";
import { TallyBrand } from "../../../features/onboarding/components/brand/tally-brand.tsx";
import { useOnboardingFlow } from "../../../features/onboarding/lib/flow-state.ts";

export const Route = createFileRoute("/(auth)/onboarding/tally")({
  component: OnboardingTally,
});

function OnboardingTally() {
  const company = useOnboardingFlow((s) => s.companyId);
  return (
    <OnboardingShell
      header={
        <OnboardingHeader
          center={<Stepper current={4} titles={STEP_TITLES} />}
          right={
            <Link
              to="/onboarding/done"
              className="inline-flex items-center gap-1 text-xs text-muted hover:text-ink-2"
            >
              <span>Skip</span>
              <ChevronRight size={14} />
            </Link>
          }
        />
      }
      brand={<TallyBrand />}
      footer="Migration is optional · your trial continues while you decide when to import history"
    >
      <Hero
        title="Bring your Tally history, or do it later."
        description={
          company
            ? "Optional step. Your workspace and free trial are already live, so migration should never block the first meaningful session."
            : "Optional step. Migration should never block the first meaningful session."
        }
      />
      <TallyForm />
    </OnboardingShell>
  );
}
